export default theme => ({
  menuButton: {
    marginLeft: 12,
    marginRight: 20,
  },

});
